<script>
	export let issues;
	export let approvedIssues;

	import Split from "./SplitForm.svelte";
	import Edit from "./EditForm.svelte";
	import ApprovedIssues from "./ApprovedIssues.svelte";
	import SuccessPage from "../../../../../../src/components/Success/SuccessPage.svelte";
	import { DynamicComponent } from "../../../../../../src/store/store";
	import { Row } from "@sveltestrap/sveltestrap";
</script>

<main>
	{#if $DynamicComponent == 1}
		<svelte:component this={ApprovedIssues} {issues} {approvedIssues} />
	{:else if $DynamicComponent == 2}
		<svelte:component this={Edit} {issues} />
	{:else if $DynamicComponent == 3}
		<svelte:component this={Split} {issues} />
	{:else if $DynamicComponent == 4}
		<Row class="border-detail ">
			<svelte:component this={SuccessPage} />
		</Row>
	{/if}
</main>

<style>
	:global(.border-detail) {
		border: 0.5px solid gray;
		margin-left: 0px !important;
		border-radius: 10px;
		/* overflow: hidden; */
		box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5);
	}
</style>
